 <template>
    <div class="bibliometric "> 
        <div class="page-banner" > 
            <div class="banner-search">
                <div class="search-tit "> 文献检索 </div>
                <div class="search-cont">
                    <div class="cont-tit">检索信息：</div>
                    <div class="cont">
                        <el-row  type="flex" class="row-bg" justify="space-between" v-for="(item,index) in searchList" :key='index'>
                            <el-col :span='2'>
                                <el-button @click='add_row()' v-if='index==0' :disabled='searchList.length==searchInfoList.length' plain type="primary" icon='el-icon-plus'> </el-button>
                                <el-select v-else v-model="item.relation" placeholder="请选择">
                                    <el-option
                                        v-for="item in relationList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span='4'>
                                <el-select   v-model="item.fieldName" placeholder="请选择">
                                    <el-option
                                        v-for="item in searchInfoList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span='10'>  
                                <el-input  v-if="item.fieldName!='year'" v-model="item.keyWord"  placeholder="请输入内容"></el-input>
                                <div v-else class="search-timer"> 
                                    <el-date-picker 
                                        align='center'
                                        value-format='yyyy'
                                        format='yyyy年'
                                        v-model="item.timer[0]"
                                        type="year" >
                                    </el-date-picker> 
                                    <b>至</b>  
                                    <el-date-picker 
                                        align='center'
                                        value-format='yyyy'
                                        format='yyyy年'
                                        v-model="item.timer[1]"
                                        type="year"  >
                                    </el-date-picker> 
                                </div> 
                            </el-col>
                            <el-col :span='4'>
                                <el-select   v-model="item.isAccurate" placeholder="请选择">
                                    <el-option
                                        v-for="item in queryType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span='2'>
                                <el-button class="delete-btn" v-if='index!=0' type="text" @click="row_delete(item,index)">删除</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="search-footer">
                    <div class="search-btn ">
                        <div class="ai-btn" @click="search_click('click')">
                            <span class="icon search-icon"></span>
                            <span class="search-txt" >搜索</span> 
                        </div>
                        
                    </div>
                    <div class="analysis-btn"  >
                        <div  v-if="!isSearch"  @click="toAnalysis">查看分析池 <i class="el-icon-d-arrow-right"></i> </div>
                    </div>
                </div>
            </div> 
        </div>
        <!-- 分析介绍 -->
        <div v-if="!isSearch">
            <ul class="atlas-info">
                <li class="page-list" v-for="(item,index) in infoList" :key="index">
                    <p class="list-title "><span class="search-txt">{{item.title}}</span></p>
                    <div class="list-info">
                        <div class="info-pic">
                            <img :src="item.url" alt="">
                        </div>
                        <div class="info-text">{{item.text}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 检索列表 -->
        <div v-else class="page-cont" >
            <div class="page-top"> 
                <!-- <div class="top-tab">
                    <span class="tab-active">检索列表 </span> 
                    <span @click="toAnalysis "> 分析池列表 （{{analysisNum}}） </span> 
                </div>  -->
                <div class="top-right"> 
                    <div class="right-btn">
                        <!-- <el-button type="primary" plain :disabled='tableList.length==0' @click="batch_click('batch')">批量文献计量分析</el-button>   -->
                        <el-button type="primary" plain :disabled='tableList.length==0' :loading="analysisLoadign" @click="add_analysis('batch')"> 批量加入分析池</el-button>
                        <!-- 2026·06·12 全部加入分析池按钮暂时隐藏 ，加入分析池增加了条数限制判断-->
                        <!-- <el-button type="success" plain :disabled='tableList.length==0' :loading="allAnalysisLoadign" @click="all_analysis('all')"> 全部加入分析池</el-button> -->
                        <el-button type="danger" plain :disabled='tableList.length==0' @click="cancel_batch">重新选择</el-button>     
                    </div> 
                    <p class="change-num" v-if='chooseNum!=0'>已选择<span>{{ chooseNum }}</span>条数据</p>  
                    <!-- <el-button type="primary" plain :disabled='tableList.length==0' @click="analysis_click('batch')">分析池（90）</el-button> -->
                </div>
                <div>
                    <div  class="analysis-btn"  @click="toAnalysis">
                        查看分析池（{{analysisNum}}）<i class="el-icon-d-arrow-right"></i> 
                    </div>
                    <p class="tips">最多允许加入{{totalLimit}}条数据</p>
                </div>
                
            </div>
            <div class="bibliometric-cont"  >
                <div class="cont-right">   
                    <div class="table-list" v-loading="tableLoad">
                        <el-table
                            ref='tableList'
                            :header-cell-style="{background:'#396de7',color:'#fff'}" 
                            :data="tableList"
                            :row-key="(row) => { return row.id }" 
                            @selection-change="selectChange"
                            border>
                                <el-table-column v-removeAriaHidden type="selection" width="55" :reserve-selection="true"></el-table-column>
                                <el-table-column
                                    label="中文题名"  
                                    prop="cnTitle"  
                                    width='400'
                                >
                                    <template slot-scope="scope">
                                        <p class="txt-overflow1" v-html="scope.row.cnTitle"></p>
                                    </template>
                                </el-table-column> 
                                <el-table-column 
                                    prop="author"
                                    label="作者" 
                                    width='340'>
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :disabled='scope.row.author.length<15' :content="scope.row.author" placement="bottom-start">
                                            <p class="txt-overflow1" v-html="scope.row.author"></p>
                                        </el-tooltip> 
                                    </template>
                                </el-table-column>
                                <el-table-column 
                                    prop="source"
                                    label="来源" >
                                    <template slot-scope="scope">
                                        <p class="txt-overflow1" v-html="scope.row.source"></p>
                                    </template>
                                </el-table-column>
                                <el-table-column 
                                    prop="year"
                                    width="100"
                                    label="发表年份">
                                </el-table-column>
                                <el-table-column
                                    label="操作" 
                                    show-overflow-tooltip
                                    width="180"
                                >
                                    <template slot-scope="scope">
                                        <el-button class="table-column-btn" type="text"  @click="toDetails(scope.row)">查看详情</el-button>
                                        <el-button class="table-column-btn" type="text"  @click="add_analysis('alone',scope.row)">加入分析池</el-button>    
                                    </template>
                                </el-table-column>
                        </el-table>
                        <el-pagination 
                            class="page-wrap"  
                            @current-change="changePage" 
                            @size-change="sizeChange"
                            background
                            :current-page="pageInfo.pageNum" 
                            :page-count="pageInfo.pageTotal" 
                            :page-size="pageInfo.pageSize"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            :total="pageInfo.total"
                            layout="total, sizes, prev, pager, next, jumper" >
                        </el-pagination>
                    </div> 
                </div>
            </div> 
        </div>  
    </div>
</template>

<script> 
import {bibliometricsPage,bibliometricsFace,bibliometricsAddAnalysisPool,bibliometricsAddAllAnalysisPool} from '../io/api.js'

// 分析池
import bibliometricAnalysis from './bibliometric/bibliometric_analysis.vue'
import {mapState,mapActions} from 'vuex'
import bibliometricData from './bibliometric/bibliometricData.js'  
export default {
    components: {  
        bibliometricAnalysis
    },
    data() {
        return {  
            isSearch:false,
            isAtlas:false,
            isShowAnalysis:false,
            analysisLoadign:false,
            allAnalysisLoadign:false,
            searchForm:{
                fieldName:'', 
                list:[], 
                faceName:'',
                faceValue:'',
                ids:[]//期刊数据ID-献计量统计图表bibliometrics_journal使用 
            },
            // analysisNum:0,
            searchList:[],
            infoList:bibliometricData.infoList,
            letfNav:bibliometricData.letfNav,
            relationList:bibliometricData.relationList,
            queryType:bibliometricData.queryType,
            searchInfoList:bibliometricData.searchInfoList,
            navIndex:0,
            tableLoad:false, 
            tableList:[],
            navLoad:false,
            batchDetails:[],
            keyWord:[],
            chooseNum:0,
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },   
            totalLimit:2000,//最多允许加入2000条数据
        }
    },
    computed: {
        ...mapState({
            analysisNum:state=>state.bibliometric.analysisNum,
        }), 
        batchIdsArr:{
            get(){return this.$store.state.bibliometric.batchIdsArr},
            set(val){this.$store.state.bibliometric.batchIdsArr=val}
        },
    },
    watch: {

    },
    mounted() {
        let list = this.searchInfoList.slice(0,3) 
        list.forEach((item,index)=>{
            let obj={ 
                relation:index>0?'AND':'',
                fieldName:item.value,
                keyWord:'',
                timer:['',''], 
                isAccurate:'2', 
            }  
            this.searchList.push(obj) 
            // this.searchList[0].keyWord='咳嗽'
        })   
    },
    methods: { 
        ...mapActions(['getAnalysisNum']),
        search_click(type){
            // if(type=='click'){ 
            let num =0; 
            //高级检索时候过滤掉keyWord为空的数据
            let list= [];
            this.keyWord=[];
            this.searchList.forEach((item,index) => {
                if(item.fieldName=='year'){
                    let timerArr=[...item.timer] 
                    let timer = timerArr&&timerArr.filter((item)=>{ return item&& item.trim()})
                    item.keyWord=timer&&timer.join('-') 
                }
                if(item.keyWord!=''){
                    num+=1; 
                    this.keyWord.push(item.keyWord)
                    list.push(item)
                }
            });     
            //搜索词为空 
            if(num==0){
                this.$message.error( '请输入检索内容～')
                return
            }  
            this.isShowAnalysis=false; 
            this.cancel_batch()
            this.pageInfo.pageNum=1; 
            this.searchForm.faceValue='';
            this.searchForm.faceName='';

            this.searchForm.list=JSON.parse(JSON.stringify(this.searchList)); 
            this.searchForm.list.forEach(item=>{
                delete item.timer
            })
            this.getList();
            this.getAnalysisNum();
            this.isSearch=true;
            this.letfNav.forEach(item=>{
                if(item.navType){
                    this.getLeftNav(item.navType);
                }
            }) 
            
        },  
        analysis_click(data){ 
            this.isShowAnalysis=data; 
        }, 
        add_row(){ 
            let obj={ 
                relation:'AND',
                fieldName:this.searchInfoList[this.searchList.length].value,
                keyWord:'',
                timer:['',''], 
                isAccurate:'2', 
            }  
            this.searchList.push(obj)
        },
        row_delete(item,index){ 
            this.searchList.splice(index,1);
        },
        getLeftNav(faceName){
            this.navLoad=true;
            this.searchForm.faceName=faceName;
            let params={
                // faceValue:this.searchForm.faceValue,//	分面值 分面时传  
                page:this.pageInfo.pageNum,
                limit:this.pageInfo.pageSize, 
                ...this.searchForm
            }
            bibliometricsFace(params).then(res=>{
                let data=res.data;
                if(data.code==0){
                    this.letfNav.forEach((item,index)=>{
                        if(item.navType==faceName){
                           item.list=data.data||[]
                        }
                    })
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
                this.navLoad=false
            })
        },
        //检索分页列表
        getList(num){
            if(num){
                this.pageInfo.pageNum=num
            }
            this.tableLoad=true;   
            let params={  
                page:this.pageInfo.pageNum,
                limit:this.pageInfo.pageSize, 
                ...this.searchForm
            }    
            // params=JSON.stringify(params)  
            bibliometricsPage(params).then(res=>{
                let data=res.data;
                this.tableLoad=false;
                if(data.code==0){
                    this.tableList=data.data.list||[];
                    this.pageInfo.total=data.data.totalCount||1;
                    this.pageInfo.pageTotal=data.data.totalPage||1; 
                    this.$nextTick(()=>{
                        if(this.batchIdsArr.length!=this.pageInfo.total){
                            this.toggleSelection(this.batchDetails)
                        }else{
                            //回显需要id
                            let arr = [];
                            this.batchIdsArr.forEach(item=>{
                                let obj={
                                    id:item
                                }
                                arr.push(obj)
                            }) 
                            this.toggleSelection(arr)
                        }
                    })
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            }).catch(err => {
                reject(err.data)
                this.tableLoad=false;
            })
        },
        //加入分析池
        add_analysis(type,row){
            let arr=[]; 
            let total = this.batchIdsArr.length+this.analysisNum;
            if(total>this.totalLimit){
                let msg = ''
                if(this.analysisNum>this.totalLimit){
                    msg = `最多允许加入${this.totalLimit}条数据，分析池已有${this.analysisNum}条数据，请您先删除部分数据再进行操作！`
                }else{
                    msg = `最多允许加入${this.totalLimit}条数据，分析池已有${this.analysisNum}条数据，您最多可加入${this.totalLimit-this.analysisNum}条数据！`
                }
                 
                this.$message.warning(msg);
                return
            }
            if(type=='batch'){ 
                if(this.batchDetails.length==0){
                    this.$message.error('请选择分析数据！');
                    return
                }else{
                    this.analysisLoadign=true;
                    arr=this.batchIdsArr;
                }
            }else{
                arr.push(row.id)
            }
            bibliometricsAddAnalysisPool(arr).then(res=>{
                let {data,code,msg} = res.data;
                if(code==0){
                    this.$message.success('加入分析池成功！');
                    this.getAnalysisNum();
                    this.cancel_batch()
                }else{
                    this.$message.error(msg,'加入分析池失败～');
                }
                this.analysisLoadign=false;
            })
        },
        toAnalysis(){
            let url= this.$router.resolve({
                path:'bibliometricAnalysis',
                query:{ 
                    changeflag:2
                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} ) 
        },
        // 数据回显
        toggleSelection(rows) {  
            this.$nextTick(() => {
                setTimeout(() => { 
                    if (rows && this.tableList.length != 0) {
                        this.tableList.forEach((row) => { 
                            rows.forEach((item) => { 
                                if (row.id == item.id) { this.$refs.tableList.toggleRowSelection(row, true) } 
                            })
                        })
                    } else {
                        this.$refs.tableList.clearSelection();
                    } 
                }, 0);
            });
        },  
        selectChange(val){ 
            if(this.batchIdsArr.length!=this.pageInfo.total){
                this.batchDetails=val;
                this.batchIdsArr=[]
                this.batchDetails.forEach(item => {
                    this.batchIdsArr.push(item.id)
                });
                this.chooseNum=this.batchIdsArr.length;
            }
              
        },
        // 批量加入，删除，取消
        batch_click(type){
            if(this.batchDetails.length==0){
                 this.$message.error({
                    message:'请选择分析数据！',
                    duration: 2000,
                });
            }else{ 
               this.isShowAnalysis=true; 
            }
        }, 
        //全部加入分析池
        all_analysis(){  
            this.$refs.tableList.clearSelection(); // 清空当前所有选中项
            this.tableList.forEach(row => {
                this.$refs.tableList.toggleRowSelection(row, true); // 手动设置选中状态为 true
            }); 
             
            this.chooseNum=this.pageInfo.total;
            this.allAnalysisLoadign=true;
            let params={  
                page:this.pageInfo.pageNum,
                limit:this.pageInfo.pageSize, 
                ...this.searchForm
            }  
            bibliometricsAddAllAnalysisPool(params).then(res=>{
                let {data,code,msg}=res.data; 
                if(code==0){
                    this.batchIdsArr=data.ids||[];
                    this.chooseNum=this.batchIdsArr.length;  
                    this.$nextTick(()=>{
                        this.$refs.tableList.clearSelection();
                    })
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.allAnalysisLoadign=false;
                this.getAnalysisNum();
            }).catch(err => {
                reject(err.data)
                this.allAnalysisLoadign=false;
            })
        },
        cancel_batch(){
            this.isAtlas=false;
            this.batchDetails=[];
            this.batchIdsArr=[];
            this.chooseNum=0;
            if(this.isSearch){ 
                this.$nextTick(()=>{
                    this.$refs.tableList.clearSelection();
                }) 
            }
        }, 
        

        toDetails(row){
            let path='bibliometricDetails'
            if(this.$route.path === '/bibliometricOut'){ 
                path='bibliometricDetailsOut'
            }
            let url= this.$router.resolve({
                path,
                query:{
                    id:row.id,
                    changeflag:2
                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} ) 
        },
        // 切换分页
        changePage(num) {
            this.pageInfo.pageNum=num;
            this.getList()
        },
        // 
        sizeChange(val){
            this.pageInfo.pageSize=val;
            this.getList();
            // this.search_click();
        },
    }
}
</script>
<style lang='less' scoped>
@import url('./bibliometric/index.less');
.bibliometric{
    padding-bottom: 40px;
    min-height: 800px;
    .analysis-btn{
        color: #396de7;
        // background-color: #ffffff;
        font-size: 18px;
        // width: 136px;
        height: 40px;
        line-height: 40px;
        border-radius: 12px; 
        font-weight: bold;
        cursor: pointer; 
        text-align: center;
    }
    .tips{
        color: red;
    }
    .search-footer{
        padding-left: 136px;
        display: flex;
        .analysis-btn{
            width: 136px;
            color: #fff;
            font-weight: normal;
        }
    }
    .atlas-info{
        width: 1200px;
        margin: 40px auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between; 
        .page-list{
            width: 580px;
            margin-bottom: 30px;
        }
        .list-title{ 
            padding : 10px 0;
            color: #396de7;
            .search-txt{
                font-size: 20px;
                font-weight: bold;
            }
            // margin-left: 20px;
        }
        .list-info{
            display: flex;
            justify-content: space-between;
            .info-pic{
                margin-top: 8px;
                width: 170px;
                // height: 100px;
                img{
                    display: block;
                    width: 100%;
                }
            }
            .info-text{
                width: 400px;
                line-height: 28px;
                font-size: 16px;
                font-weight: bold;
            }
        } 
    }
    .bibliometric-cont{ 
        display: flex;
        justify-content: space-between;
        width: 1200px ;
        margin: 20px auto;
        .cont-left{
                // padding-top:80px;
            width: 244px; 
            .left-nav{ 
                border: 2px solid #396de7;
                .nav-tit{
                    height: 40px;
                    background: #396de7;
                    line-height: 40px;
                    font-size: 16px;
                    font-weight: bold;
                    color: #fff;
                    padding-left: 20px;
                }
                .list-box{
                    // max-height: 380px;
                    // overflow-y: scroll;
                }
                .nav-list{
                    .list{
                        display: flex;
                        justify-content: space-between;
                        padding-left: 20px;
                        height: 40px;
                        line-height: 40px;
                        &:hover,&.active{
                            background: #F1F5FE;
                        } 
                        p{
                            white-space:nowrap;//(文字不换行);
                            overflow:hidden;//( 溢出隐藏);
                            text-overflow:ellipsis;//( 文本有溢出加省略号 );
                            display:inline-block;//(flex布局)
                        }
                        .list-label{
                            width: 140px;
                            cursor: pointer;
                        }
                        .list-num{
                            width:70px;
                            padding-right: 20px;
                            text-align: right;
                        }
                    }
                }
                .no-data{
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                }
            }
        }
        .cont-right{ 
            // width: 930px;
            width: 100%; 
            .table-list{
                // margin-top: 20px;;
                .txt-overflow1{
                    max-width:100%;
                    white-space:nowrap;//(文字不换行);
                    overflow:hidden;//( 溢出隐藏);
                    text-overflow:ellipsis;//( 文本有溢出加省略号 );
                    display:inline-block;//(flex布局)
                }
            }
        }
    }
    .search-txt{
        background-image: linear-gradient(
            270deg,
            rgba(129, 255, 217, 1) 0,
            rgba(103, 238, 255, 1) 11.146801%,
            rgba(70, 180, 255, 1) 33.139325%,
            rgba(22, 93, 255, 1) 100%
            ); 
        overflow-wrap: break-word;
        color: rgba(22, 93, 255, 1);
        font-size: 18px;
        font-family: PingFang-SC-Medium;
        font-weight: normal;
        text-align: left;
        white-space: nowrap; 
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; 
    }
}
</style>